import { render, staticRenderFns } from "./descriptionUpdateReloadPanel.vue?vue&type=template&id=c4ef6fd8&scoped=true"
import script from "./descriptionUpdateReloadPanel.vue?vue&type=script&lang=js"
export * from "./descriptionUpdateReloadPanel.vue?vue&type=script&lang=js"
import style0 from "./descriptionUpdateReloadPanel.vue?vue&type=style&index=0&id=c4ef6fd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ef6fd8",
  null
  
)

export default component.exports